module.exports = __webpack_public_path__ + "static/img/top1_i1_nav.3cdf2f5c.png";